import { styles } from './ModalSide-styles'
import React from 'react'
import { cn } from 'ethcss'
import { Typography } from '../../atoms/Typography'
import Icon from '../../blocks.simple/icon/icon'
import translate from '../../core/translate'
import { Button } from '../Button'

interface IModalSideProps {
    children: React.ReactNode
    position?: 'left' | 'right'
    title?: string
    onClose?: () => void
    onReject?: () => void
    onAccept?: () => void
    rejectText?: React.ReactNode
    acceptText?: React.ReactNode
    acceptDisabled?: boolean
}

export const ModalSide: React.FC<IModalSideProps> = ({
    children,
    position,
    title,
    onClose,
    onReject,
    onAccept,
    rejectText,
    acceptText,
    acceptDisabled,
}) => {
    return (
        <div
            className={cn(
                styles.modalSide,
                styles.modalSideDefaultWidth,
                position ? styles[`modalSidePosition-${position}`] : styles['modalSidePosition-left']
            )}
        >
            <div className={styles.header}>
                {title && (
                    <Typography type={'title'} className={styles.title}>
                        {title}
                    </Typography>
                )}
                <Icon
                    type={'close'}
                    size={16}
                    containerClass={styles.closeIcon}
                    onClick={() => (onClose ? onClose() : onReject && onReject())}
                />
            </div>
            {children}
            <div className={styles.footer}>
                <Button className={styles.button} onClick={() => onReject && onReject()}>
                    {rejectText || translate('close')}
                </Button>
                <Button
                    className={styles.button}
                    onClick={() => onAccept && onAccept()}
                    mod={'fillBrand'}
                    disabled={acceptDisabled}
                >
                    {acceptText || translate('save')}
                </Button>
            </div>
        </div>
    )
}
